import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMathSquareRoot = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M18.25 3.25h-5.063a3 3 0 0 0-2.856 2.082L6.5 17.25l-2.078-7.064A2 2 0 0 0 2.504 8.75H1.75m11 2 4.5 6.5m-4.5 0 4.5-6.5"
	})]
});
const ForwardRef = forwardRef(SvgMathSquareRoot);
export { ForwardRef as ReactComponent };
